import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Input from 'components/inputs/Input/Input';
import Button2 from 'components/buttons/Button2/Button2';
import { ReactComponent as PaperPlane } from 'assets/icons/paper-plane.svg';
import withTitle from 'hocs/WithTitle';
import { useRecoverPassword } from './useRecoverPassword';
import styles from './style.cssmodule.css';

const Recover = ({ handleFormTypeChange }) => {
  const { formatMessage: t } = useIntl();

  const {
    fields,
    changeField,
    errors,
    isSubmitting,
    handleSubmit,
  } = useRecoverPassword({
    handleFormTypeChange,
  });

  // Autofocus on email field when component loads
  useEffect(() => {
    // Timeout to ensure DOM is properly rendered
    const timer = setTimeout(() => {
      const emailInput = document.querySelector('input[name="email"]');
      if (emailInput) {
        emailInput.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Form submission handling (Enter key and prevent page reload)
  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <form onSubmit={handleFormSubmit} noValidate>
      <div className={styles.inputGrid}>
        <Input
          label={t({ id: 'field.emailExplicitConnexionLinkedAccount' })}
          type="email"
          name="email"
          autoComplete="username email"
          disabled={isSubmitting}
          value={fields.email}
          error={errors.email}
          aria-invalid={errors.email ? 'true' : 'false'}
          aria-describedby={errors.email ? 'email-error' : undefined} // Error reference for screen readers
          required
          onChange={({ target: { value: newEmail } }) => changeField({ name: 'email', value: newEmail })}
        />
      </div>

      <Button2
        htmlType="submit"
        type="primary"
        loading={isSubmitting}
        disabled={isSubmitting}
        className={styles.recoverPasswordButton}
        size="medium"
        aria-label={t({ id: 'button.sendInstructions' })}
      >
        {t({ id: 'button.sendInstructions' })}
        <PaperPlane aria-hidden="true" />
      </Button2>
    </form>
  );
};
Recover.propTypes = {
  handleFormTypeChange: PropTypes.func,
};
Recover.defaultProps = {
  handleFormTypeChange: () => {},
};

module.exports = withTitle('pageTitle.recoverPassword')(Recover);



// WEBPACK FOOTER //
// ./routes/login/components/cpm_manager/components/Recover/Recover.jsx